"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadTZZH = void 0;
var react_1 = __importStar(require("react"));
require("./index.less");
var vertical_scroll_1 = require("../vertical_scroll");
/**
 * 头部投资组合
 * @returns
 */
function HeadTZZH() {
    var _a = (0, react_1.useState)([]), data = _a[0], SetData = _a[1];
    var getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var back, todata, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, $.ajax({
                                url: '//quote.eastmoney.com/newapi/portfolio.js',
                                type: 'GET',
                                dataType: 'jsonp',
                                jsonpCallback: 'portfolioRate',
                                cache: true
                            })];
                    case 1:
                        back = _a.sent();
                        todata = [];
                        if (back.ReturnRateDaily) {
                            todata.push("<a href=\"http://group.eastmoney.com/index.html\" target=\"_blank\">\u9AD8\u624B\u65E5\u6536\u76CA\u8FBE<span>".concat(back.ReturnRateDaily, "</span></a>"));
                        }
                        if (back.ReturnRateWeekly) {
                            todata.push("<a href=\"http://group.eastmoney.com/index.html\" target=\"_blank\">\u9AD8\u624B\u5468\u6536\u76CA\u8FBE<span>".concat(back.ReturnRateWeekly, "</span></a>"));
                        }
                        if (back.ReturnRateMonthly) {
                            todata.push("<a href=\"http://group.eastmoney.com/index.html\" target=\"_blank\">\u9AD8\u624B\u6708\u6536\u76CA\u8FBE<span>".concat(back.ReturnRateMonthly, "</span></a>"));
                        }
                        if (back.ReturnRateYearly) {
                            todata.push("<a href=\"http://group.eastmoney.com/index.html\" target=\"_blank\">\u9AD8\u624B\u5E74\u6536\u76CA\u8FBE<span>".concat(back.ReturnRateYearly, "</span></a>"));
                        }
                        SetData(todata);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    (0, react_1.useEffect)(function () {
        getData();
        var cd = setInterval(function () {
            getData();
        }, 120 * 1000);
        return function () {
            clearInterval(cd);
        };
    }, []);
    if (data.length == 0)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: "t" },
            react_1.default.createElement("a", { href: "https://group.eastmoney.com/index.html" },
                react_1.default.createElement("span", { className: "icon_group2" }),
                "\u6295\u8D44\u7EC4\u5408"),
            "\uFF1A"),
        react_1.default.createElement("div", { className: "bs_group" },
            react_1.default.createElement(vertical_scroll_1.VerticalScroll, { htmllist: data }))));
}
exports.HeadTZZH = HeadTZZH;
